import { resolveComponent as o, openBlock as t, createElementBlock as a, createVNode as n, normalizeClass as d } from "vue";
import { _ as l } from "./_plugin-vue_export-helper-dad06003.js";
import { C as s } from "./ChevronDoubleLeftIcon-1f939a0e.js";
const b = {
  components: {
    ChevronDoubleLeftIcon: s
  },
  props: {
    fold: {
      type: Boolean,
      default: !1
    }
  }
}, c = {
  type: "button",
  class: "bg-white dark:bg-neutral-900 enabled:hover:bg-gray-50 dark:hover:bg-neutral-800 border enabled:border-gray-200 enabled:dark:border-neutral-800 enabled:text-gray-700 enabled:dark:text-neutral-300 enabled:hover:text-gray-800 enabled:dark:hover:text-neutral-100 disabled:ct-fg-disabled disabled:border-gray-200 disabled:dark:border-neutral-800 disabled:cursor-default rounded-r-md py-4 px-1"
};
function u(f, i, e, p, m, _) {
  const r = o("ChevronDoubleLeftIcon");
  return t(), a("button", c, [
    n(r, {
      class: d(["transition-transform transform", { "rotate-180": e.fold }])
    }, null, 8, ["class"])
  ]);
}
const v = /* @__PURE__ */ l(b, [["render", u]]);
export {
  v as B
};
